<template>
  <v-text-field
    type="tel"
    class="input-styles"
    :disabled="disabled"
    :value="phone"
    :rules="rules"
    @input="(val) => updatePhone(val)"
    label="Phone Number"
    maxlength="14"
    height="48"
    placeholder=" "
    outlined
    persistent-placeholder
    required
    @blur="blur"
    :autofocus="autofocus"
  ></v-text-field>
</template>

<script>
export default {
  name: "PhoneInput",
  data() {
    return {
      rules: [],
    };
  },
  methods: {
    phoneCheck(value) {
      const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return pattern.test(value) || "Invalid phone number.";
    },
    requiredCheck(value) {
      return !!value || "Required.";
    },
    blur() {
      this.rules = [this.phoneCheck, this.requiredCheck];
    },
  },
  props: {
    disabled: Boolean,
    phone: String,
    updatePhone: Function,
    autofocus: Boolean,
  },
};
</script>
